export function formatBillingItemDescription(description?: string): string {
  if (!description) return '-';

  // Translate English descriptions to German
  let germanDescription = description;
  if (germanDescription.includes('Processing Fee - Sammelauftrag')) {
    germanDescription = germanDescription.replace(
      'Processing Fee - Sammelauftrag',
      'Bearbeitungsgebühr - Sammelauftrag'
    );
  } else if (germanDescription.includes('Usage Fee - Track Utilization')) {
    germanDescription = germanDescription.replace(
      'Usage Fee - Track Utilization',
      'Nutzungsgebühr - Gleisnutzung'
    );
  } else if (germanDescription.includes('Processing Fee')) {
    germanDescription = germanDescription.replace(
      'Processing Fee',
      'Bearbeitungsgebühr'
    );
  } else if (germanDescription.includes('Usage Fee')) {
    germanDescription = germanDescription.replace(
      'Usage Fee',
      'Nutzungsgebühr'
    );
  } else if (germanDescription.includes('Track Utilization')) {
    germanDescription = germanDescription.replace(
      'Track Utilization',
      'Gleisnutzung'
    );
  }

  // Add formatting logic (e.g., highlighting, bold, etc.)
  return germanDescription.replace(/\n/g, '<br/>');
}
